import { api } from '@/core/api/request'
import { logger } from '@/core/app/logger'
import { SheetListResponseSchema } from '@/schemas/v2'
import type { SheetListResponse } from '@/schemas/v2'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

export async function fetchSheets(options?: FetchOptions): Promise<SheetListResponse> {
  const url = `${BASE}/api/v2/sheets`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return SheetListResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
